import { FaqItem, SubEntityType } from '../../models';
import { knowledgeBaseHttp } from '../knowledge-base-api';

export const getFAQs = async (
  groupId: number,
  locale: string,
  types?: string[],
  additionalArgs?: { [key: string]: string | number }
): Promise<FaqItem[]> => {
  try {
    let url = `/group/${groupId}/${SubEntityType.FrequentlyAskedQuestions}?marketLocale=${encodeURIComponent(locale)}`;

    if (Array.isArray(types) && types.length > 0) {
      additionalArgs = { ...additionalArgs, types: types.join('|') };
    }

    if (additionalArgs) {
      const params = new URLSearchParams();
      Object.entries(additionalArgs).forEach(([key, value]) => {
        params.append(key, String(value));
      });

      const queryString = params.toString();
      if (queryString) {
        url += `&${queryString}`;
      }
    }

    const response = await knowledgeBaseHttp.get<FaqItem[]>(url);
    return response?.data ?? [];
  } catch (error) {
    console.error(`Error fetching FAQ:`, error);
    return [];
  }
};
